import PdfViewerScreen from 'features/PdfViewerScreen/PdfViewerScreen';
import React from 'react';

export default function DisclosureViewer() {
  return <PdfViewerScreen />;
}
